module.exports = __webpack_public_path__ + "img/produitslaitiers.d18557f8.png";